import { render, staticRenderFns } from "./available-houses.vue?vue&type=template&id=fffc5c02"
import script from "./available-houses.vue?vue&type=script&lang=js"
export * from "./available-houses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports